import { z } from 'zod';

export const tariffResubmissionRequestSchema = z.object({
  id: z.guid(),
  claimID: z.guid(),
  tariffID: z.guid(),
  createdBy: z.guid(),
  createdAt: z.coerce.date(),
  status: z.enum(['Pending', 'Included', 'Cancelled']),
});
